import { UseFormReturn } from "react-hook-form";
import { useFields } from "../../../api/useFields";
import { findField } from "../../../utils/findField";
import { EditableOrderPayments } from "./EditableOrderPayments";
import { ReadOnlyOrderPayments } from "./ReadOnlyOrderPayments";

type OrderPaymentsProps = {
    orderId?: number;
    orderTotal: number;
    entityForm?: UseFormReturn;
    paymentStatus: string;
    isReadOnly?: boolean;
    recordType: "create" | "update" | "detail";
    existingPayments?: Array<any>;
};

export const OrderPayments = ({
    orderId,
    orderTotal,
    entityForm,
    paymentStatus,
    isReadOnly = false,
    recordType,
    existingPayments = [],
}: OrderPaymentsProps) => {
    const { formatedFields, status: fieldsStatus } = useFields("orders_payments");

    if (paymentStatus !== "paid") return null;
    if (fieldsStatus !== "success") return null;

    const paymentMethodField = findField(formatedFields, "payment_method");
    const amountField = findField(formatedFields, "amount");

    if (!paymentMethodField || !amountField) return null;

    if (isReadOnly) {
        return (
            <ReadOnlyOrderPayments
                orderId={orderId}
                orderTotal={orderTotal}
                paymentMethodField={paymentMethodField}
                amountField={amountField}
            />
        );
    }

    if (!entityForm) return null;

    return (
        <EditableOrderPayments
            orderId={orderId}
            orderTotal={orderTotal}
            entityForm={entityForm}
            paymentStatus={paymentStatus}
            recordType={recordType}
            paymentMethodField={paymentMethodField}
            amountField={amountField}
            existingPayments={existingPayments}
        />
    );
};

